import React, {useState,useEffect,useRef} from 'react'
import { Formik, Field } from 'formik'
import { Table,Button,Icon,Form,Select,Input,List,Image,Label,TextArea,Message,Modal } from 'semantic-ui-react'
import {WindowReload, WindowURL, WindowLocation} from '../../config/settings'
import Alertmessage from '../../config/alert'
import axios from 'axios'
import renderHTML from 'react-render-html'
import {validatecapcha} from './validate'

import UploadDocument from './upload'

export default function OpenAccountDocument(props) {


	function CallbackFunction(data){
		props.active(data);
	}
	function CallbackState(data){
		props.callstate(data);
	}


	/*-------------------------------------------------------------------------
	 Forms: Adding
	--------------------------------------------------------------------------*/
	const [state,setstate] = useState({
		upload_document:'',
		captcha_text:'',
		captcha_value:'',
		captcha_show:''
	});



	function handleSubmitForm(values, props){

		CallbackState({
			upload_document:values.upload_document,
			captcha_text:values.captcha_text,
			captcha_value:values.captcha_value,
			captcha_show:values.captcha_show,
			file:values.upload_document,
		});
		CallbackFunction(7);

	}


  function CapatchaGenerator(){
	   var length = 5;
	   var result           = '';
	   var characters       = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789';
	   var charactersLength = characters.length;
	   for ( var i = 0; i < length; i++ ) {
	      result += characters.charAt(Math.floor(Math.random() * charactersLength));
	   }
		 setstate({
			 ...state,
			 captcha_text:'',
	 		 captcha_value:result,
	 		 captcha_show:result
		 });
	}


	/*-------------------------------------
		Content
	--------------------------------------*/
	const [content, setcontent] = useState({
			form: {
				attach: {
					title:'',
					content:'',
					text_upload:'',
					message_code:'',
				},
			},
	});
	function ContentApplication(){
		let formData = new FormData();
		formData.append('type','content');
		axios.post('/content/request.php',formData)
		.then(function (response) {
				let obj = response.data;
				setcontent({
					...content,
					form: {
						attach: {
							title:obj.form.attach.title,
							content:obj.form.attach.content,
							message_code:obj.form.attach.message_code,
							text_upload:obj.form.attach.text_upload,
						}
					},
				});
		})
		.catch(function (error){
		});
	}


	useEffect(()=>{
		ContentApplication();
		CapatchaGenerator();
	},[]);


	return (
		<React.Fragment>

				<Form autocomplete="off">
					<Formik
					  enableReinitialize
						initialValues={state}
						validationSchema={validatecapcha}
						onSubmit={handleSubmitForm}
						render={formProps => {
						const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps

						function SetFileDocument(file){
							setFieldValue('upload_document',file);
						}

						return(
			         <div className="open-account-panel">
                 <div className="open-account-panel-header">
                   <h2>Attach Supporting Document (Optional)</h2>
                </div>
			            <div className="open-account-panel-body">
									  <div className="document-wrapper">
											<UploadDocument data={SetFileDocument} />

											<div className="captcha-wrapper">

											  <div className="captcha-text">{values.captcha_show}</div>


													<Form.Group widths="equal">
				                    <Field name="captcha_text">
				                        {({ field, form }) => (
				                        <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
				                          <Input {...field} onChange={handleChange} className="captcha"/>
				                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
				                        </Form.Field>
				                        )}
				                    </Field>
				                  </Form.Group>


												<Message visible warning>{content.form.attach.message_code}</Message>
												<Button content='Try another code' className="basic" icon='refresh' onClick={()=>CapatchaGenerator()}/>

											</div>


										</div>
									</div>{/*.panel-body*/}
			            <div className="open-account-panel-footer">
										<div className="account-panel-footer">
											<div><Button content='Back' className="primary" icon='left arrow' labelPosition='left' onClick={()=>CallbackFunction(5)}/></div>
											<div><Button content='Send Application' className="primary" icon='lock'  onClick={handleSubmit}/></div>
										</div>
									</div>
			         </div>

						 )}}/>
					</Form>
    </React.Fragment>
  )
}
